export default {
  empty_list: 'No categories yet',
  uses_restaurant_open_times: 'Uses restaurant open times',
  products_creation_disabled:
    'Due to active integration with {{integration}}, new products creation is not allowed. If you need to change the menu, please make the changes in {{integration}} and sync the menu.',
  buttons: {
    add_category: 'Add category',
  },
  toasts: {
    something_went_wrong: 'Something went wrong',
  },
};
